import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router'

import '../styles/register.css';

import RegisterForm from '../../user/containers/RegisterFormContainer';
import Footer from '../../core/components/FooterComponent';

import logo from '../../assets/images/logo-blanc.png'

class Login extends Component {
    constructor(props) { 
        super(props);
        this.state={}
    }

   render() {

        return (
            <div className="page-register">
                <div className="header" >
                    <Container>
                      <Row>
                        <Col>
                          <Link to="/"><img src={logo} alt=""  className="logo" /></Link>
                        </Col>
                        <Col className="login-bloc">
                             <Link to="/login"><Button className="login">Se connecter</Button></Link>
                        </Col>
                      </Row>

                       <Row>
                        <Col className="center">
                          <h1 className="h1">
                            Déposer votre candidature en ligne
                          </h1>
                        </Col>
                      </Row>
                    </Container>
                </div>


            <Container>
                
               <div className="form-title" >
                   Pour être agréés HomeServe, les professionnels de notre réseau ont signé plusieurs engagements qui garantissent à nos clients une qualité de service optimale.
               </div>

               <RegisterForm />

            </Container>

            <Footer />

          </div>
        )
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/home/components/Register.js